module.exports = __webpack_public_path__ + "img/491.89d75e27.jpg";